export class HotPoint {
  _id?: string;
  image: string = '';
  content: string = '';
  x: number = 0;
  y: number = 0;
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/models/hot-point.model.ts